import React from "react";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { HiShieldCheck, HiLightningBolt } from "react-icons/hi";
import profileImg from "../assets/profile.png";
import Navbar from "../components/navbar";
import { motion } from "framer-motion";

const teamMembers = [
  {
    name: "Prakhar Parikh",
    role: "Full Stack Engineer & Security Analyst",
    linkedin: "https://www.linkedin.com/in/prakhar-parikh",
    github: "https://github.com/prakhar-thecoder",
  },
  {
    name: "Pandya Shivang",
    role: "Full Stack Developer",
    linkedin: "https://www.linkedin.com/in/shivang-pandya-72837927b",
    github: "https://github.com/shivang-pandya",
  },
];

const about = () => {
  return (
    <div className="min-h-screen bg-bg">
      <Navbar />
      
      <div className="max-w-6xl mx-auto px-6 py-20">
        <motion.div
          className="text-center mb-20"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6">
            About <span className="text-fg">KeySpyder</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Built by passionate cybersecurity students dedicated to creating innovative monitoring solutions
          </p>
        </motion.div>

        <motion.div
          className="grid md:grid-cols-2 gap-8 mb-20"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="bg-gray-800 rounded-2xl p-8 shadow-lg border border-gray-700">
            <div className="w-14 h-14 bg-gradient-to-br from-fg to-blue-600 rounded-xl flex items-center justify-center mb-6">
              <HiShieldCheck className="text-white" size={28} />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Our Mission</h3>
            <p className="text-gray-400 leading-relaxed">
              To provide cutting-edge keystroke monitoring tools that help organizations maintain security while respecting privacy and ethical boundaries.
            </p>
          </div>

          <div className="bg-gray-800 rounded-2xl p-8 shadow-lg border border-gray-700">
            <div className="w-14 h-14 bg-gradient-to-br from-fg to-blue-600 rounded-xl flex items-center justify-center mb-6">
              <HiLightningBolt className="text-white" size={28} />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Our Vision</h3>
            <p className="text-gray-400 leading-relaxed">
              To become the leading platform for real-time keystroke analysis, empowering security professionals with actionable insights.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <h2 className="text-4xl font-bold text-white text-center mb-12">
            Meet Our Team
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {teamMembers.map((member, index) => (
              <motion.div
                key={index}
                className="group bg-gray-800 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-700"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.5 + index * 0.1 }}
                whileHover={{ y: -8 }}
              >
                <div className="relative h-48 bg-gradient-to-br from-fg to-blue-600 flex items-center justify-center overflow-hidden">
                  <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                  <img
                    src={profileImg}
                    alt={member.name}
                    className="w-32 h-32 rounded-full border-4 border-white shadow-xl relative z-10 group-hover:scale-110 transition-transform duration-300"
                  />
                </div>

                <div className="p-8 text-center">
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {member.name}
                  </h3>
                  <p className="text-fg font-medium mb-6">{member.role}</p>

                  <div className="flex justify-center gap-4">
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 bg-gray-700 hover:bg-fg rounded-xl flex items-center justify-center transition-all duration-300 group/link"
                    >
                      <FaLinkedin className="text-gray-300 group-hover/link:text-white transition-colors" size={24} />
                    </a>
                    <a
                      href={member.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 bg-gray-700 hover:bg-fg rounded-xl flex items-center justify-center transition-all duration-300 group/link"
                    >
                      <FaGithub className="text-gray-300 group-hover/link:text-white transition-colors" size={24} />
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>

      <footer className="bg-gray-950 text-white py-8 text-center mt-20 border-t border-gray-800">
        <p className="text-gray-500">© 2024 KeySpyder. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default about;
